<template>
  <a-card :bordered="false">
    <div>
      <div class="operation-wrap">
        <div>
        </div>
        <div>
          <a-button type="primary" @click="addUser">
            {{ $t('ADD') || '添加' }}
          </a-button>
        </div>
      </div>
      <a-table
        row-key="id"
        :default-sort="table.sort"
        :data-source="table.data"
        @sort-change="onSortChange"
        style="width: 100%">
        <a-table-column
          data-index="loginName"
          title="账号"
          width="180">
        </a-table-column>
        <a-table-column
          data-index="userName"
          title="姓名"
          width="180">
        </a-table-column>
        <a-table-column
          data-index="sex"
          title="性别"
          width="180">
          <template slot-scope="text,record">
            {{ $dict('SEX', record.sex) }}
          </template>
        </a-table-column>
        <a-table-column
          data-index="email"
          title="邮箱"
          width="180">
        </a-table-column>
        <a-table-column
          data-index="isActive"
          title="是否有效"
          width="180">
          <template slot-scope="text,record">
            <a-tag type="success" v-if="record.isActive==='YES'">是</a-tag>
            <a-tag type="danger" v-if="record.isActive==='NO'">否</a-tag>
          </template>
        </a-table-column>
        <a-table-column
          data-index="date"
          :title="$t('OPERATION')||'操作'">
          <template slot-scope="text, record">
            <a-button type="link" @click="editUser(record.id)">{{ $t('EDIT') || '编辑' }}
            </a-button>
            <a-button type="link" @click="deleteUser(record.id)">{{ $t('REMOVE') || '删除' }}
            </a-button>
          </template>
        </a-table-column>
      </a-table>
    </div>
    <a-modal :footer="null"
             @close="closeForm"
             :title="form.data.id?'用户编辑':'用户添加'"
             v-model="form.visible">
      <user-edit
        v-if="form.visible"
        :user-id="form.data.id"
        :on-cancel-handler="closeForm"
        :on-submit-handler="closeForm">
      </user-edit>
    </a-modal>
  </a-card>
</template>

<script>
import {
  _queryUsers,
  _deleteUser,
} from '@/api/sys/sysUserApi';
import UserEdit from './UserEdit.vue';

async function getUserList() {
  let direction = this.table.sort.order;
  if (direction) {
    direction = direction === 'ascend' ? 'ASC' : 'DESC';
  }
  const {content, totalElements} = await _queryUsers({
    page: this.table.query.page,
    size: this.table.query.size,
    sort: this.table.sort.prop,
    direction,
    date: this.table.query.date,
  });
  this.table.data = content;
  this.table.query.total = totalElements;
}

function addUser() {
  this.form.data.id = null;
  this.form.visible = true;
}

function editUser(userId) {
  this.form.data.id = userId;
  this.form.visible = true;
}

function closeForm() {
  this.form.data.id = null;
  this.form.visible = false;
  this.getUserList();
}

async function asyncUsers() {
}

async function deleteUser(userId) {
  this.$confirm({
    title: this.$t('CONFIRM_REMOVE'),
    content: '',
    onOk: async () => {
      const result = await _deleteUser(userId);
      if (result) {
        this.$message.success(this.$t('REMOVE_SUCCESS'));
        this.getUserList();
      }
    },
  });
}


function handleSizeChange(val) {
  this.table.query.size = val;
  this.getUserList();
}

function handlePageChange(val) {
  this.table.query.page = val;
  this.getUserList();
}

export default {
  name: 'UserList',
  components: {UserEdit},
  data() {
    return {
      form: {
        data: {
          id: null,
        },
        visible: false,
      },
      table: {
        data: [],
        query: {
          page: 1,
          size: 100,
          total: 0,
        },
        sort: {
          prop: 'createAt',
          order: 'descending',
        },
      },
    };
  },
  methods: {
    getUserList,
    deleteUser,
    editUser,
    addUser,
    closeForm,
    handlePageChange,
    handleSizeChange,
    asyncUsers,
    onSortChange() {
    },
  },
  created() {
    this.getUserList();
  },
};
</script>

<style scoped>

</style>
